import { createInjectionKey as i } from "../../_utils/vue/create-injection-key.js";
const e = i("n-dialog-provider"), n = i("n-dialog-api"), t = i("n-dialog-reactive-list");
export {
  n as dialogApiInjectionKey,
  e as dialogProviderInjectionKey,
  t as dialogReactiveListInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/context.js
// module id = 463
// module chunks = 41